export default "__VITE_ASSET__D9_$gYOI__"